import FetchInterceptor from "configs/FetchInterceptor";

class InventoriesServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/inventories/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getAllV2(requestBody) {
    const apiUrl = "/core/v2/inventories/booking/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getListV2(requestBody) {
    const apiUrl = "/core/v2/inventories/booking/get/list";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getByIds(requestBody) {
    const apiUrl = "/core/v1/inventories/get/data";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getByIdsV2(requestBody) {
    const apiUrl = "/core/v2/inventories/booking/get/data";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/inventories/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getLatestBuyingPrices(requestBody) {
    const apiUrl = "/core/v1/latest/buying/prices";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async findInventory(requestBody) {
    const apiUrl = "/core/v1/inventories/get";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
}

export default InventoriesServices;
